<template>
  <div class="picker idFill"
       :class="mustFlag">
    <h6><span></span>邮箱</h6>
    <div class="text">
      <input
        placeholder="请输入邮箱"
        v-model.trim="email"
        @change="getMess">
    </div>
  </div>
</template>

<script>
  export default {
    props: ["mustFlag"],
    data () {
      return {
        email : ''
      }
    },
    methods:{
      getMess(){
        this.$emit('transMess' , ['email' , this.email])
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/EmailFill/EmailFill.vue